export default "__VITE_ASSET__f91c0c87__"